import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import fbGrabedPost from '@/data/fbGrabedPost/store.js'
import igGrabedPost from '@/data/igGrabedPost/store.js'
import author from '@/data/author/store.js'
import contentTemplate from '@/data/contentTemplate/store.js'
import post from '@/data/post/store.js'
import postTag from '@/data/postTag/store.js'
import webInfo from '@/data/webInfo/store.js'
import message from '@/data/message/store.js'
import systemLog from '@/data/systemLog/store.js'
import user from '@/data/user/store.js'

import qa from '@/data/qa/store.js'
import qaGroup from '@/data/qaGroup/store.js'
import homeBanner from '@/data/homeBanner/store.js'
import order from '@/data/order/store.js'
import product from '@/data/product/store.js'
import productTag from '@/data/productTag/store.js'
import productCategory from '@/data/productCategory/store.js'
import productCategoryGroup from '@/data/productCategoryGroup/store.js'

// 第二階段
import newHomeBanner from '@/data/newHomeBanner/store.js'
import store from '@/data/store/store.js'
import productInfo from '@/data/productInfo/store.js'
import productInfoTag from '@/data/productInfoTag/store.js'
import originInfo from '@/data/originInfo/store.js'
import originInfoProduct from '@/data/originInfoProduct/store.js'
import teamBuying from '@/data/teamBuying/store.js'

// 2022/12 改版
import coupon from '@/data/coupon/store.js'
import gift from '@/data/gift/store.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    contentTemplate,
    message,
    systemLog,
    fbGrabedPost,
    igGrabedPost,
    post,
    postTag,
    author,
    webInfo,
    user,

    qa,
    qaGroup,
    homeBanner,
    order,
    product,
    productTag,
    productCategory,
    productCategoryGroup,

    // 第二階段
    newHomeBanner,
    store,
    productInfo,
    productInfoTag,
    originInfo,
    originInfoProduct,
    teamBuying,

    // 2022/12 改版
    coupon,
    gift
  },
  state: {
    admin: {
      Profile: {
        Name: ''
      }
    }
  },
  getters: {
    adminHasFBAccessToken: state => {
      return state.admin && state.admin.Profile && state.admin.Profile.FBAccessTokenExpiredAt
    },
    adminHasFBPageAccessToken: state => {
      return state.admin && state.admin.Profile && state.admin.Profile.FBPageAccessTokenExpiredAt
    },
    adminHasIGAccessToken: state => {
      return state.admin && state.admin.Profile && state.admin.Profile.IGAccessTokenExpiredAt
    },

    adminMissValidFBAccessToken: (state, getters) => {
      return !getters.adminHasFBAccessToken || getters.adminFBAccessTokenExpired
    },
    adminMissValidFBPageAccessToken: (state, getters) => {
      return !getters.adminHasFBPageAccessToken || getters.adminFBPageAccessTokenExpired
    },
    adminMissValidIGAccessToken: (state, getters) => {
      return !getters.adminHasIGAccessToken || getters.adminIGAccessTokenExpired
    },

    adminFBAccessTokenExpired: state => {
      var result = false
      try {
        let expiredAt = state.admin.Profile.FBAccessTokenExpiredAt
        if (expiredAt) {
          result = moment(expiredAt).unix() * 1000 < new Date().getTime()
        }
      } catch (err) {
        console.error(err)
      }
      return result
    },
    adminFBPageAccessTokenExpired: state => {
      var result = false
      try {
        let expiredAt = state.admin.Profile.FBPageAccessTokenExpiredAt
        if (expiredAt) {
          result = moment(expiredAt).unix() * 1000 < new Date().getTime()
        }
      } catch (err) {
        console.error(err)
      }
      return result
    },
    adminIGAccessTokenExpired: state => {
      var result = false
      try {
        let expiredAt = state.admin.Profile.IGAccessTokenExpiredAt
        if (expiredAt) {
          result = moment(expiredAt).unix() * 1000 < new Date().getTime()
        }
      } catch (err) {
        console.error(err)
      }
      return result
    },

    adminFBAccessTokenValid: (state, getters) => {
      return !getters.adminFBAccessTokenExpired
    },
    adminFBPageAccessTokenValid: (state, getters) => {
      return !getters.adminFBPageAccessTokenExpired
    },
    adminIGAccessTokenValid: (state, getters) => {
      return !getters.adminIGAccessTokenExpired
    }
  },
  mutations: {
  },
  actions: {

  }
})
